import { InjectionToken, Type } from '@angular/core';

export const UNIVERSAL_CREATE_SMART_ROCK_CTA_COMPONENT = new InjectionToken<Type<unknown> | null>(
  'UNIVERSAL_CREATE_SMART_ROCK_CTA_COMPONENT',
  {
    providedIn: 'root',
    factory: () => null,
  }
);
